import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { createBrowserHistory as createHistory } from 'history';
import App from './containers/App';
import ErrorBoundary from './components/ErrorBoundary';
//import registerServiceWorker from './registerServiceWorker';
import createStore from './redux/createStore';
import config from './config';

// import RSuite styles with our overrides
import './rsuite.less';

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();
const store = createStore(history, {});
const CheckErrorBoundary = config.errorBoundary ? ErrorBoundary: Fragment;
ReactDOM.render(
  <Provider store={store} >
    <ConnectedRouter history={history}>
      <CheckErrorBoundary>
       <App />
      </CheckErrorBoundary>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js